import React from 'react';
import '../node_modules/boxicons/css/boxicons.min.css';
import '../src/assets/css/style.css';
import { AuthContextProvider } from '../src/hooks/useAuthContext';

export const wrapRootElement = ({ element }) => {
	return <AuthContextProvider>{element}</AuthContextProvider>;
};
